import React from "react";
import { Link } from 'react-router-dom';
import CloseIcon from "../icons/CloseIcon";

const ConfirmationExpiredPage = () => { 

    return (
        <section className="account py-40">           
            <div className="container container-lg">            
                <div className="row gy-4">                   
                    <div className="col-xl-3"></div>
                    <div className="col-xl-5">
                        <div className="row gy-4">
                            <div className="col-xl-6">
                                <div className="logo px-16 d-block">
                                    <Link to='/' className='mobile-menu__logo'>
                                        <img src='../../assets/images/logo/dhofar-logo.svg' alt='Logo' />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-xl-6 d-flex justify-content-end align-items-center">
                                <Link to='/'>
                                    <CloseIcon size={14} className='text-neutral-900' />
                                </Link>
                            </div>
                        </div>                        
                        <div className="product-dContent border rounded-24 p-20 mt-30"> 
                            <div className="mb-20">   
                                <div className="mb-24">
                                    <div className="pt-20 pb-20">Account verification link has expired or your account is already confirmed. In case account has not been confirmed please use forgot password form to send new confirmation link.</div>
                                </div>                                    
                            </div>                                
                            <div className="my-24">
                                <p className="text-neutral-900">
                                    <b>
                                        Click here to &nbsp;
                                        <Link to="/login" className="btn-primary text-decoration-underline">
                                            Log in
                                        </Link>
                                    </b>
                                </p>
                            </div>   
                            <div className="my-24">
                                <p className="text-neutral-900">
                                    <b>
                                        Forgot your password?&nbsp;
                                        <Link to="/forgot-password" className="btn-primary text-decoration-underline">
                                            Reset it
                                        </Link>
                                    </b>
                                </p>
                            </div>    
                        </div>                  
                    </div>                    
                </div>
            </div>                    
        </section>
    );
};

export default ConfirmationExpiredPage;
